import script from "./Plan.vue?vue&type=script&setup=true&lang=js"
export * from "./Plan.vue?vue&type=script&setup=true&lang=js"

import "./Plan.vue?vue&type=style&index=0&id=2ec85b60&lang=scss"

const __exports__ = script;

export default __exports__